import { Star, Quote } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

const testimonials = [
  {
    name: "Ana Paula Ribeiro",
    business: "Bloom Studio",
    segment: "Fisioterapeuta",
    location: "Curitiba, PR",
    text: "Criei minha marca profissional em 1 minuto. Meus clientes adoraram o visual novo!",
    rating: 5,
    timeAgo: "2 semanas",
    highlight: true,
    gradient: "linear-gradient(135deg, #10B981 0%, #059669 100%)"
  },
  {
    name: "Carlos Eduardo",
    business: "Urban Eats",
    segment: "Fornecimento de Alimentos",
    location: "Campinas, SP",
    text: "Economizei mais de R$2.000 que gastaria com designer. A logo ficou incrível e profissional!",
    rating: 5,
    timeAgo: "1 mês",
    highlight: false,
    gradient: "linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)"
  },
  {
    name: "Fernanda Costa",
    business: "Bella Moda",
    segment: "Vestuário",
    location: "Salvador, BA",
    text: "Finalmente tenho uma identidade visual profissional para minha loja. Recomendo demais!",
    rating: 4,
    timeAgo: "3 semanas",
    highlight: false,
    gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)"
  }
];

export const SocialProof = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-background content-below-fold">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14 lg:mb-16">
          {/* Badge com contador */}
          <div className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2 rounded-full mb-6 shadow-lg">
            <Star className="h-4 w-4 fill-current" />
            <span className="text-sm font-bold">+200 marcas criadas</span>
          </div>
          
          <h2 className="heading-section text-foreground mb-4 text-balance">
            O que nossos clientes dizem?
          </h2>
          <p className="subtitle-section max-w-2xl mx-auto">
            Empreendedores de todo o Brasil já transformaram seus negócios com uma identidade visual profissional.
          </p>
        </div>

        {/* Testimonials - Horizontal scroll on mobile, grid on desktop */}
        <div className="flex overflow-x-auto snap-x snap-mandatory gap-4 pb-4 pt-4 -mx-4 px-4 sm:mx-0 sm:px-0 sm:overflow-visible sm:grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-6 scrollbar-hide">
          {testimonials.map((testimonial, index) => (
            <Card 
              key={index} 
              className={cn(
                "flex-shrink-0 w-[85vw] max-w-[340px] sm:w-auto sm:max-w-none snap-center",
                "p-5 sm:p-6 bg-white border border-slate-200 shadow-[0_8px_30px_rgba(0,0,0,0.04)] rounded-2xl",
                "hover:shadow-[0_16px_48px_rgba(0,0,0,0.06)] hover:border-primary/30 hover:-translate-y-1 transition-all duration-500 relative overflow-visible"
              )}
            >
              <div className="flex items-start gap-3 mb-5">
                <Avatar className="w-12 h-12 border-2 border-slate-100 shadow-sm flex-shrink-0">
                  <AvatarFallback 
                    className="font-bold text-white text-sm"
                    style={{ background: testimonial.gradient }}
                  >
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </AvatarFallback>
                </Avatar>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-foreground truncate">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground truncate">{testimonial.business}</p>
                  <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                    <span className="text-xs text-primary font-medium">{testimonial.segment}</span>
                    <span className="text-muted-foreground">·</span>
                    <span className="text-[10px] text-muted-foreground bg-muted px-2 py-0.5 rounded-full">
                      há {testimonial.timeAgo}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground mt-0.5">{testimonial.location}</p>
                </div>
              </div>
              
              {/* Estrelas */}
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star 
                    key={i} 
                    className={cn(
                      "h-4 w-4",
                      i < testimonial.rating 
                        ? "fill-yellow-400 text-yellow-400" 
                        : "fill-muted text-muted"
                    )} 
                  />
                ))}
              </div>
              
              <div className="relative">
                <Quote className="h-8 w-8 text-primary/30 absolute -top-2 -left-2 rotate-180" />
                <p className="text-muted-foreground pl-6 italic leading-relaxed">
                  "{testimonial.text}"
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
